<template>
  <BlankPage :status="pageStatus" />
</template>

<script>
import liff from '@line/liff';
import BlankPage from '@/components/BlankPage.vue';
import rmuService from '@/services/rmuService';

export default {
  components: {
    BlankPage,
  },
  data() {
    return {
      pageStatus: 'blank',
    };
  },
  created() {
    const vm = this;
    // 取得query string
    const liffId = vm.getQueryString('liffId');
    const redirectUri = vm.getQueryString('redirectUri');

    if (!redirectUri) {
      // 缺少導頁參數，直接去錯誤頁
      vm.$router.replace({ name: 'Error' });
      return;
    }

    // 有liffId判斷為liff 流程，否則前往line login流程
    if (liffId) {
      vm.processLiff(liffId, redirectUri);
    } else {
      vm.goToLineLogin(redirectUri);
    }
  },
  methods: {
    // 處理 liff 流程
    processLiff(liffId, redirectUri) {
      const vm = this;

      // liff init
      liff.init({ liffId })
        .then(() => {
          // 取得參數
          const {
            companyId, companyTagNo, menuObjectNo,
          } = vm.$route.query;

          // 參數齊全才做處理
          if ((companyId && companyTagNo) || menuObjectNo) {
            return liff.getProfile()
              .then((profile) => {
                let tagPromise = Promise.resolve();
                let clickedPromise = Promise.resolve();

                // 有 companyId && companyTagNo 做貼標
                if (companyId && companyTagNo) {
                  tagPromise = vm.postMemberTag(companyId, profile.userId, companyTagNo, redirectUri);
                }
                // 有 menuObjectNo 做點擊紀錄
                if (menuObjectNo) {
                  clickedPromise = rmuService.createQRCodeMessageClick({ accountId: profile.userId, menuObjectNo: parseInt(menuObjectNo, 10) }).toPromise();
                }

                return Promise.all([tagPromise, clickedPromise]);
              });
          }

          return Promise.resolve();
        })
        .catch(() => {
          // 初始化失敗，去錯誤頁
          vm.$router.replace({ name: 'Error', params: { status: 'unstableNetwork' } });
        })
        .finally(() => {
          // 導頁，有liff.state時為liff流程中，不導頁
          if (!new URLSearchParams(vm.$route.query).has('liff.state')) {
            window.location.replace(redirectUri);
          }
        });
    },
    // 前往line login
    goToLineLogin(redirectUri) {
      const vm = this;

      // 取得參數
      const {
        companyId, companyTagNo, menuObjectNo,
      } = vm.$route.query;

      if (!companyId) {
        // line login缺少companyId，直接去錯誤頁
        vm.$router.replace({ name: 'Error' });
        return;
      }

      const params = new URLSearchParams({ companyId, redirectUri });

      // 有companyTagNo才新增
      if (companyTagNo) {
        if (Array.isArray(companyTagNo)) {
          companyTagNo.forEach((tagNo) => {
            params.append('companyTagNo', tagNo);
          });
        } else {
          params.append('companyTagNo', companyTagNo);
        }
      }

      // 有menuObjectNo才新增
      if (menuObjectNo) {
        params.append('menuObjectNo', menuObjectNo);
      }

      const href = window.location.href
        .split('?').shift()
        .split('#').shift()
        .replace(/\/$/, '')
        .replace(vm.$route.path, '');

      const redirectQueryString = params.toString();
      const redirectUrl = encodeURIComponent(`${href}/richMenu/lineLoginCallback?${redirectQueryString}`);
      const comUrl = JSON.parse(process.env.VUE_APP_USE_ENV) ? '${VUE_APP_API_COM_URL}' : process.env.VUE_APP_API_COM_URL;
      const lineLoginUrl = `${comUrl}/api/v1/linecode?DirectUrl=${redirectUrl}&CompanyId=${companyId}`;

      // 跳轉至 Line Login
      window.location.assign(lineLoginUrl);
    },
    // 取得query string中的參數
    // 因會橫跨liff流程，也需處理liff.state的情況
    getQueryString(name) {
      const vm = this;

      // 先直接從網址取
      const result = vm.$route.query[name];
      if (result) return result;

      // 取不到，嘗試從liff.state取
      const state = vm.$route.query['liff.state'];

      if (state) {
        return new URLSearchParams(state).get(name);
      }

      return null;
    },
    // 會員貼標
    postMemberTag(companyId, accountId, companyTagNo, redirectUri) {
      const tagNos = Array.isArray(companyTagNo) ? companyTagNo : [companyTagNo];
      return this.$store.dispatch('mbc/postMemberTag', {
        companyId,
        accountType: 'LineBind',
        accountId,
        createUser: 'System',
        source: 'RichMenuUri',
        sourceRemark: redirectUri.substring(0, 100),
        companyTagNo: tagNos.map((x) => parseInt(x, 10)),
      });
    },
  },
};
</script>
